import { FeatureCollection } from 'geojson'
import { useFeatureIdentify } from 'map-feature-info'
import { useMap } from 'ms-map-gl'
import { FC, useEffect } from 'react'
import { useNumericProperties } from '~map-preview/states/map'
import { getBoundaryFeature } from './getBoundaryFeature'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useAggregateLabel } from '~map-preview/states/boundaries'

type PopupPluginProps = {
  layer: string
  geojson: FeatureCollection
}

export const BoundaryClickPlugin: FC<PopupPluginProps> = (props) => {
  const { layer, geojson } = props
  const { setSideBar, setOpenDrawer, setOpenMapFeatureInfo } = useMapNavStore()

  const { default: map } = useMap()
  const { identify } = useFeatureIdentify()
  const numericProperties = useNumericProperties()
  const aggregateLabel = useAggregateLabel()

  useEffect(() => {
    if (!map) return
    map.on('click', layer, (e: any) => {
      const feature = getBoundaryFeature(
        geojson,
        e?.features[0],
        numericProperties,
        aggregateLabel
      )

      if (!feature) return

      identify(feature)
      setSideBar('mapFeatureInfo')
      setOpenDrawer(true)
      setOpenMapFeatureInfo(true)
    })
  }, [map, numericProperties])

  return <></>
}
